export default "__VITE_ASSET__1knXRiKR__"